<div class="configuration-email-jobs-view-part">

	<grid-content [setup]="setup" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="emailJobs()"></grid-content>

</div>